import { CreateRepositoryInfoDto, CreateRepositoryInfoResponse, DeleteRepositoryQueryDto, FindOneRepositoryQueryDto, FindOneRepositoryResponse, FindRepositoriesQuery, FindRepositoriesResponse } from '@/@types/theoryGit/repositoryInfo';
import { GitApiAxiosBase } from '@/repository/base/axiosBase';

export class RepositoryInfoRepository {
  private readonly requestBasePath = 'v1/repository-info';
  private readonly axios = new GitApiAxiosBase();
  /**リポジトリ登録 */
  async createRepository(params: CreateRepositoryInfoDto) {
    const response = await this.axios.post<CreateRepositoryInfoResponse>(
      this.requestBasePath,
      params,
    );
    return response.data;
  }

  /**リポジトリ一覧取得 */
  async findRepositories(projectId: number) {
    const query: FindRepositoriesQuery = {
      'project-id': projectId,
    };
    const response = await this.axios.get<FindRepositoriesResponse>(
      this.requestBasePath,
      { params: query },
    );
    return response.data;
  }

  /**リポジトリ詳細取得 */
  async findOneRepository(repositoryInfoId: number, projectId: number) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    const query: FindOneRepositoryQueryDto = {
      'project-id': projectId,
    };
    const response = await this.axios.get<FindOneRepositoryResponse>(
      endPoint,
      { params: query },
    );
    return response.data;
  }

  /**リポジトリ削除 */
  async deleteRepository(repositoryInfoId: number, projectId: number) {
    const endPoint = `${this.requestBasePath}/${repositoryInfoId}`;
    const query: DeleteRepositoryQueryDto = {
      'project-id': projectId,
    };
    await this.axios.delete(endPoint, { params: query });
  }
}
